<template>
  <el-dialog :title="'选择科室&病区'" :visible.sync="show" :center="true" width="513px" @close="cancel" :close-on-click-modal="false">
    <div>
      <el-input v-model="keyWord" suffix-icon="el-icon-search" @change="inputChange" placeholder="输入编号/关键字搜索科室" clearable></el-input>
    </div>
    <div style="margin-top: 10px">
      <el-table :data="data" row-key="idGroup" height="270" ref="multipleTable" border style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <el-table-column type="selection" width="40" :reserve-selection="true"> </el-table-column>
        <el-table-column prop="deptName" label="科室名称" width="180"> </el-table-column>
        <el-table-column prop="wardName" label="病区名称"> </el-table-column>
      </el-table>
    </div>
    <div class="tagBox">
      <span class="title">已选择：</span>
      <el-tag v-for="tag in selectionList" :key="tag.idGroup" @close="handleClose(tag)" closable type="info">
        {{ tag.deptName + " " + (tag.wardName ? tag.wardName : "") }}
      </el-tag>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
      <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["show", "data", 'oldData'],
  data () {
    return {
      keyWord: "",
      selectionList: [],
      needInitialize: true,
    };
  },
  // watch: {
  //   show(){
  //     if (this.oldData.length != 0) {
  //     this.$nextTick(()=>{
  //       this.handleSelectionChange(this.oldData)
  //       this.oldData.forEach(res=>{
  //         this.$refs.multipleTable.toggleRowSelection( res,true)
  //       })

  //     })
  //   }
  //   }

  // },
  updated () {
    if (this.oldData.length != 0 && this.needInitialize) {
      this.oldData.forEach(item => {
        this.$nextTick(() => {
          this.handleSelectionChange(this.oldData)
          this.data.find(obj => {
            if (item.idGroup === obj.idGroup) {
              this.$refs.multipleTable.toggleRowSelection(obj, true)
            }
          })
        })
      })
      this.needInitialize = false;
    }
  },
  methods: {
    cancel () {
      this.selectionList = []
      this.$refs.multipleTable.clearSelection();
      this.$emit("closeEvt");
    },

    inputChange (val) {
      this.$emit("filterMethod", val);
    },
    handleSelectionChange (val) {
      this.selectionList = val;
    },
    submit () {
      this.$emit("getData", this.selectionList);
    },
    handleClose (val) {
      this.selectionList.splice(this.selectionList.indexOf(val), 1);
      this.$refs.multipleTable.toggleRowSelection(val, false);
    },
  },
};
</script>

<style lang="scss" scoped>
.tagBox {
  margin-top: 10px;
  min-height: 100px;

  .title {
    font-weight: 500;
    font-size: 16px;
  }

  .el-tag {
    margin: 1px 3px;
  }
}

/deep/.el-dialog__body {
  overflow: auto !important;
}
</style>
